var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.99 511.99",
    style: {
      enableBackground: "new 0 0 511.99 511.99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C9CF4F"
    },
    cx: 255.995,
    cy: 261.89,
    r: 250.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEAD7"
    },
    d: "M405.62,381.994c-2.129-7.822-2.879-15.954-2.217-24.034l5.687-57.401 c1.933-23.408-1.634-46.86-11.997-67.939c-26.712-54.338-20.627-58.165-21.463-112.465c0-11.042-8.952-19.994-19.994-19.994 s-19.994,8.952-19.994,19.994c0,7.133,0,201.789,0,201.027c0,3.201-0.35,6.318-1,9.324v28.5c0,24.251-19.729,43.98-43.98,43.98 c-16.105,0-71.635,0-109.43,0c16.817,23.408,39.833,41.737,66.547,52.831c0.166,0.069,0.331,0.138,0.496,0.208 c22.222,9.385,37.176,30.285,39.537,53.969c51.857-6.584,98.753-29.054,135.672-62.369L405.62,381.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEAD7"
    },
    d: "M107.013,100.86l-6.089-5.642c-9.388-8.698-24.185-8.134-32.883,1.253 c-8.698,9.388-8.134,24.185,1.254,32.883l37.719,34.949V100.86H107.013z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9D6BF"
    },
    d: "M80.46,109.022c-4.806-4.453-7.283-10.505-7.405-16.611c-1.812,1.094-3.509,2.436-5.015,4.062 c-8.698,9.388-8.134,24.185,1.254,32.883l37.719,34.949v-30.68L80.46,109.022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E3369"
    },
    d: "M291.663,0c-15.165,0-126.672,0-141.701,0c-24.251,0-43.98,19.73-43.98,43.98v316.026 c0,24.251,19.73,43.98,43.98,43.98c22.153,0,119.476,0,141.701,0c24.251,0,43.98-19.73,43.98-43.98V43.98 C335.643,19.73,315.913,0,291.663,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472356"
    },
    d: "M152.968,360.006V43.98c0-24.251,19.73-43.98,43.98-43.98c-22.403,0-41.388,0-46.986,0 c-24.251,0-43.98,19.73-43.98,43.98v316.026c0,24.251,19.73,43.98,43.98,43.98c8.084,0,26.183,0,46.986,0 C172.697,403.987,152.968,384.257,152.968,360.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6393E4"
    },
    d: "M311.276,360.006c0,10.832-8.781,19.613-19.613,19.613c-15.001,0-126.538,0-141.701,0 c-10.832,0-19.613-8.781-19.613-19.613c0-9.985,0-305.853,0-316.026c0-10.832,8.781-19.613,19.613-19.613h10.806 c4.053,0,7.339,3.286,7.339,7.339v4.654c0,6.245,5.109,11.354,11.353,11.354c17.011,0,65.698,0,82.704,0 c6.244,0,11.353-5.109,11.353-11.354v-4.654c0-4.053,3.286-7.339,7.339-7.339h10.806c10.832,0,19.613,8.781,19.613,19.613 C311.276,112.004,311.276,296.598,311.276,360.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566CC3"
    },
    d: "M152.968,43.98c0-7.045,1.675-13.704,4.632-19.613h-7.638c-10.832,0-19.613,8.781-19.613,19.613 c0,10.172,0,306.041,0,316.026c0,10.832,8.781,19.613,19.613,19.613c1.574,0,4.201,0,7.638,0 c-2.958-5.909-4.632-12.568-4.632-19.613V43.98z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71457F"
    },
    d: "M245.742,31.469h-24.299c-3.922,0-7.102-3.18-7.102-7.102s3.18-7.102,7.102-7.102h24.299 c3.922,0,7.102,3.18,7.102,7.102S249.665,31.469,245.742,31.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71457F"
    },
    d: "M196.523,31.468c-3.977,0-7.102-3.264-7.102-7.102c0-4.598,4.25-7.836,8.494-6.96 c3.171,0.593,5.71,3.482,5.71,6.96C203.625,28.221,200.511,31.468,196.523,31.468z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEAD7"
    },
    d: "M140.875,223.58L140.875,223.58c-7.653,8.26-20.553,8.751-28.812,1.098l-34.151-31.643 c-8.26-7.653-8.751-20.553-1.098-28.812l0,0c7.653-8.26,20.553-8.751,28.812-1.098l34.151,31.643 C148.037,202.421,148.529,215.32,140.875,223.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9D6BF"
    },
    d: "M125.313,209.053L91.162,177.41c-5.285-4.897-7.372-11.939-6.198-18.541 c-3.015,1.065-5.826,2.846-8.15,5.354l0,0c-7.653,8.259-7.161,21.159,1.098,28.812l34.151,31.643 c8.26,7.653,21.159,7.161,28.812-1.098l0,0c2.757-2.975,4.439-6.554,5.1-10.271C139.063,215.751,131.065,214.382,125.313,209.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEAD7"
    },
    d: "M140.875,279.191L140.875,279.191c-7.653,8.26-20.553,8.751-28.812,1.098l-34.151-31.643 c-8.26-7.653-8.751-20.553-1.098-28.812l0,0c7.653-8.26,20.553-8.751,28.812-1.098l34.151,31.643 C148.037,258.032,148.529,270.931,140.875,279.191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9D6BF"
    },
    d: "M125.313,264.664l-34.151-31.643c-5.285-4.897-7.372-11.939-6.198-18.541 c-3.015,1.065-5.826,2.846-8.15,5.354l0,0c-7.653,8.259-7.161,21.159,1.098,28.812l34.151,31.643 c8.26,7.653,21.159,7.161,28.812-1.098l0,0c2.757-2.975,4.439-6.554,5.1-10.271C139.063,271.362,131.065,269.993,125.313,264.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEAD7"
    },
    d: "M140.875,334.802L140.875,334.802c-7.653,8.26-20.553,8.751-28.812,1.098l-34.151-31.643 c-8.26-7.653-8.751-20.553-1.098-28.812l0,0c7.653-8.26,20.553-8.751,28.812-1.098l34.151,31.643 C148.037,313.643,148.529,326.543,140.875,334.802z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9D6BF"
    },
    d: "M125.313,320.276l-34.151-31.643c-5.285-4.897-7.372-11.939-6.198-18.541 c-3.015,1.065-5.826,2.846-8.15,5.354l0,0c-7.653,8.26-7.161,21.159,1.098,28.812l34.151,31.643 c8.26,7.653,21.159,7.161,28.812-1.098l0,0c2.757-2.975,4.439-6.554,5.1-10.271C139.063,326.973,131.065,325.605,125.313,320.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9D6BF"
    },
    d: "M403.863,373.428c-28.787,45.256-79.378,75.285-136.987,75.285c-15.267,0-30.039-2.113-44.046-6.055 c7.865,5.107,16.205,9.528,24.95,13.16c0.165,0.069,0.331,0.138,0.496,0.208c22.222,9.385,37.176,30.285,39.537,53.969 c51.857-6.584,98.753-29.054,135.672-62.369l-17.865-65.632C404.853,379.173,404.271,376.312,403.863,373.428z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7AACF4"
    },
    d: "M232.937,357.665h-24.326c-3.926,0-7.11-3.183-7.11-7.11c0-3.927,3.183-7.11,7.11-7.11h24.326 c3.926,0,7.11,3.183,7.11,7.11S236.864,357.665,232.937,357.665z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#A0D7FB"
    },
    cx: 183.509,
    cy: 146.869,
    rx: 24.149,
    ry: 24.149
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8AC9FF"
    },
    d: "M183.512,146.871c-4.468-7.739-4.159-16.921,0.002-24.145c-4.105-0.004-8.265,1.032-12.076,3.232 c-11.55,6.668-15.507,21.437-8.839,32.986c6.668,11.55,21.437,15.507,32.986,8.839c3.81-2.2,6.788-5.285,8.837-8.842 C196.086,158.933,187.98,154.61,183.512,146.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7AACF4"
    },
    d: "M291.663,24.367h-10.806c-4.053,0-7.339,3.286-7.339,7.339v4.654c0,6.245-5.109,11.354-11.353,11.354 c-17.005,0-65.693,0-82.704,0c-6.244,0-11.353-5.109-11.353-11.354v-4.654c0-4.053-3.286-7.339-7.339-7.339h-10.806 c-10.832,0-19.613,8.781-19.613,19.613c0,2.43,0,21.177,0,48.43h180.927c0-19.146,0-35.8,0-48.43 C311.276,33.148,302.495,24.367,291.663,24.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6393E4"
    },
    d: "M130.349,43.98c0,2.43,0,21.177,0,48.43h22.619V43.98c0-7.045,1.674-13.704,4.632-19.613h-7.638 C139.13,24.367,130.349,33.148,130.349,43.98z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#A0D7FB"
    },
    cx: 258.029,
    cy: 146.869,
    rx: 24.149,
    ry: 24.149
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8AC9FF"
    },
    d: "M258.037,146.871c-4.468-7.739-4.159-16.921,0.002-24.145c-4.105-0.004-8.265,1.032-12.076,3.232 c-11.55,6.668-15.507,21.437-8.839,32.986c6.668,11.55,21.437,15.507,32.986,8.839c3.81-2.2,6.788-5.285,8.837-8.842 C270.611,158.933,262.505,154.61,258.037,146.871z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#A0D7FB"
    },
    cx: 183.508,
    cy: 219.302,
    rx: 24.149,
    ry: 24.149
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8AC9FF"
    },
    d: "M183.512,219.314c-4.468-7.739-4.159-16.921,0.002-24.145c-4.105-0.004-8.265,1.032-12.076,3.232 c-11.55,6.668-15.507,21.437-8.839,32.986c6.668,11.55,21.437,15.507,32.986,8.839c3.81-2.2,6.788-5.285,8.837-8.842 C196.086,231.376,187.98,227.053,183.512,219.314z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#A0D7FB"
    },
    cx: 258.023,
    cy: 219.302,
    rx: 24.149,
    ry: 24.149
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8AC9FF"
    },
    d: "M258.037,219.314c-4.468-7.739-4.159-16.921,0.002-24.145c-4.105-0.004-8.265,1.032-12.076,3.232 c-11.55,6.668-15.507,21.437-8.839,32.986c6.668,11.55,21.437,15.507,32.986,8.839c3.81-2.2,6.788-5.285,8.837-8.842 C270.611,231.376,262.505,227.053,258.037,219.314z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#A0D7FB"
    },
    cx: 183.508,
    cy: 292.3,
    rx: 24.149,
    ry: 24.149
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8AC9FF"
    },
    d: "M183.512,292.311c-4.468-7.739-4.159-16.921,0.002-24.145c-4.105-0.004-8.265,1.032-12.076,3.232 c-11.55,6.668-15.507,21.437-8.839,32.986c6.668,11.55,21.437,15.507,32.986,8.839c3.81-2.2,6.788-5.285,8.837-8.842 C196.086,304.374,187.98,300.051,183.512,292.311z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#A0D7FB"
    },
    cx: 258.033,
    cy: 292.3,
    rx: 24.149,
    ry: 24.149
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8AC9FF"
    },
    d: "M258.037,292.311c-4.468-7.739-4.159-16.921,0.002-24.145c-4.105-0.004-8.265,1.032-12.076,3.232 c-11.55,6.668-15.507,21.437-8.839,32.986c6.668,11.55,21.437,15.507,32.986,8.839c3.81-2.2,6.788-5.285,8.837-8.842 C270.611,304.374,262.505,300.051,258.037,292.311z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone);
export default __webpack_public_path__ + "static/media/iphone.9e20b48a855154e4c916441a3aa48718.svg";
export { ForwardRef as ReactComponent };